import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  ListItemText,
  TableContainer,
} from '@mui/material';
import { UserType, UserProductPositionQuota } from 'src/type/user';
import { convertGold } from 'src/utils/convert';
import { fNumber } from 'src/utils/format-number';

type Props = {
  user: UserType;
};

export default function PositionQuotasTable({ user }: Props) {
  const groupedProduct = (user?.userProductPositionQuotas || []).reduce<
    Record<string, UserProductPositionQuota[]>
  >((acc, transaction) => {
    const productName = transaction.product.name;

    if (!acc[productName]) {
      acc[productName] = [];
    }

    acc[productName].push(transaction);

    return acc;
  }, {});

  // เรียงตาม sequence ของ product
  const sortedEntries = Object.entries(groupedProduct).sort((a, b) => {
    const sequenceA = a[1][0]?.product?.sequence ?? 999;
    const sequenceB = b[1][0]?.product?.sequence ?? 999;
    return sequenceA - sequenceB;
  });

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left">โควต้า</TableCell>
            <TableCell align="right">Buy</TableCell>
            <TableCell align="right">Sell</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedEntries.map(([key, quotas]) => {
            const buyAmount = quotas.find((q) => q.type === 'BUY')?.amount || 0;
            const sellAmount = quotas.find((q) => q.type === 'SELL')?.amount || 0;
            const isOrnament = quotas.find((q) => q.product)?.product?.isOrnament || false;

            return (
              <TableRow key={key}>
                <TableCell>
                  <Typography variant="body2" noWrap pb={2}>
                    {key}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <ListItemText
                    primary={`${fNumber(buyAmount)} กรัม`}
                    secondary={`≈ ${fNumber(convertGold(buyAmount, 'weightBaht', isOrnament))} บาท`}
                    primaryTypographyProps={{
                      typography: 'body2',
                      noWrap: true,
                    }}
                    secondaryTypographyProps={{
                      component: 'span',
                      typography: 'caption',
                      noWrap: true,
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <ListItemText
                    primary={`${fNumber(sellAmount)} กรัม`}
                    secondary={`≈ ${fNumber(convertGold(sellAmount, 'weightBaht', isOrnament))} บาท`}
                    primaryTypographyProps={{
                      typography: 'body2',
                      noWrap: true,
                    }}
                    secondaryTypographyProps={{
                      component: 'span',
                      typography: 'caption',
                      noWrap: true,
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
